import { mapActions } from 'vuex';
import { PULSE_POLL_INTERVAL_MS } from '@/modules/pulse/utils/pulseConstants';
import { isPulseEnabled } from '@/modules/pulse/utils/pulseNavigation';

// Polls the Pulse "Needs attention" count of My View every 30s (VCITA2-15783). Belongs to the
// menu container because that is the only surface mounted on both desktop and mobile, so one
// poll feeds every badge.
export default {
  data() {
    return {
      pulseBadgePollTimer: null,
    };
  },
  computed: {
    isPulseBadgeEnabled() {
      return this.$featureFlagsLoaded() && isPulseEnabled((flag) => this.$hasFeature(flag));
    },
  },
  watch: {
    // Feature flags load asynchronously, so the poll starts on the flags rather than on mount.
    isPulseBadgeEnabled: {
      immediate: true,
      handler(isEnabled) {
        if (isEnabled) {
          this.startPulseBadgePolling();
        } else {
          this.stopPulseBadgePolling();
        }
      },
    },
  },
  beforeDestroy() {
    this.stopPulseBadgePolling();
  },
  methods: {
    ...mapActions('PulseStore', ['fetchNeedsAttentionCount']),
    startPulseBadgePolling() {
      if (this.pulseBadgePollTimer) return;
      this.fetchNeedsAttentionCount();
      this.pulseBadgePollTimer = setInterval(() => this.fetchNeedsAttentionCount(), PULSE_POLL_INTERVAL_MS);
    },
    stopPulseBadgePolling() {
      if (!this.pulseBadgePollTimer) return;
      clearInterval(this.pulseBadgePollTimer);
      this.pulseBadgePollTimer = null;
    },
  },
};
